import { useEffect } from 'react';
import LoadingCircle from 'components/LoadingCircle';
import { useRouter } from 'next/router';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function LoginRegister() {
  const { login } = useAuthUser();
  const router = useRouter();
  const redirect = router.query.redirect;

  useEffect(() => {
    login({ redirectPage: redirect, isFullUrl: true });
  }, [redirect]);

  return <LoadingCircle />;
}
